import type { HTMLAttributes } from 'react';
import styles from './VisuallyHidden.module.css';

/** Text for assistive technology only (a screen-reader sentence next to a visual chip, an extra hint). */
export function VisuallyHidden({ className, ...rest }: HTMLAttributes<HTMLSpanElement>) {
  return <span className={className ? `${styles.srOnly} ${className}` : styles.srOnly} {...rest} />;
}

export const visuallyHiddenClassName = styles.srOnly;
